import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { formatDateAU as fmtDateAU } from "../utils/formatDate";

// Render AU-local DD/MM/YYYY (blank when missing — this is a celebratory
// summary, so a dash would look odd).
function formatDateAU(raw) {
  return fmtDateAU(raw, "");
}

/* Detect mobile / tablet from the user-agent string rather than a
 * viewport-width media query. Desktop browsers with narrow windows
 * (e.g. devtools open) used to hide the QR even though the user was on
 * a laptop and couldn't tap the wallet buttons. UA-based detection
 * matches the actual capability: a phone/tablet can open Apple/Google
 * Wallet natively, so the QR is redundant there. */
function isMobileOrTabletDevice() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  // iPadOS 13+ identifies as MacIntel; check touch points to catch it.
  const isIPadOS = navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1;
  return /Mobi|Android|iPhone|iPad|iPod|Tablet|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua) || isIPadOS;
}

export default function StepConfirmation({ result, isExisting, onStartOver }) {
  const hasWallet = result && (result.appleLink || result.googleLink);
  const walletUrl = result?.appleLink || result?.googleLink;
  const isHandheld = isMobileOrTabletDevice();

  return (
    <div className="confirm-box">
      <div className="confirm-icon">✓</div>
      <div className="confirm-title">{isExisting ? "Welcome back!" : "Welcome!"}</div>
      <p className="confirm-sub">
        {isExisting
          ? "Your membership has been renewed successfully."
          : "Your membership has been activated successfully."}
      </p>

      {result && (
        <div className="confirm-details">
          {result.memberName && (
            <div className="confirm-row">
              <span className="confirm-row-label">Name</span>
              <span className="confirm-row-value">{result.memberName}</span>
            </div>
          )}
          <div className="confirm-row">
            <span className="confirm-row-label">Membership ID</span>
            <span className="confirm-row-value">{result.membershipId}</span>
          </div>
          <div className="confirm-row">
            <span className="confirm-row-label">Expiry Date</span>
            <span className="confirm-row-value">{formatDateAU(result.dateExpiry)}</span>
          </div>
        </div>
      )}

      {hasWallet && (
        <div className="confirm-wallet">
          <p style={{ fontSize: "0.85rem", fontWeight: 600, marginBottom: "0.75rem" }}>
            Add your membership card to your phone:
          </p>
          <div className="confirm-wallet-buttons">
            {result.appleLink && (
              <a href={result.appleLink} target="_blank" rel="noopener noreferrer" className="su-wallet-btn su-wallet-apple">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.52-3.23 0-1.44.64-2.2.46-3.06-.4C3.79 16.17 4.36 9.53 8.71 9.28c1.24.06 2.11.72 2.84.76.99-.2 1.94-.78 3-.66 1.28.15 2.24.73 2.87 1.78-2.49 1.53-1.9 4.89.38 5.83-.46 1.21-1.06 2.41-1.75 3.29zM12.03 9.2C11.88 7.06 13.58 5.3 15.6 5.14c.28 2.42-2.17 4.22-3.57 4.06z"/></svg>
                Add to Apple Wallet
              </a>
            )}
            {result.googleLink && (
              <a href={result.googleLink} target="_blank" rel="noopener noreferrer" className="su-wallet-btn su-wallet-google">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M12 11v2.4h3.97c-.16 1.03-1.2 3.02-3.97 3.02-2.39 0-4.34-1.98-4.34-4.42S9.61 7.58 12 7.58c1.36 0 2.27.58 2.79 1.08l1.9-1.83C15.47 5.69 13.89 5 12 5 8.13 5 5 8.13 5 12s3.13 7 7 7c4.04 0 6.72-2.84 6.72-6.84 0-.46-.05-.81-.11-1.16H12z"/></svg>
                Add to Google Wallet
              </a>
            )}
          </div>
          {walletUrl && !isHandheld && (
            <div className="confirm-wallet-qr">
              <p style={{ fontSize: "0.78rem", color: "var(--text-muted)", margin: "1rem 0 0.5rem" }}>
                Or scan the QR code to add on another device:
              </p>
              <div style={{ background: "#fff", display: "inline-block", padding: 12, borderRadius: 10 }}>
                <QRCodeSVG value={walletUrl} size={120} bgColor="#ffffff" fgColor="#000000" level="M" />
              </div>
            </div>
          )}
        </div>
      )}

      <p style={{ fontSize: "0.8rem", color: "var(--text-muted)", marginBottom: "1.5rem" }}>
        Please save your Membership ID for future reference.
      </p>

      <button
        type="button"
        className="su-btn su-btn-outline su-btn-full"
        onClick={onStartOver}
      >
        Register Another Member
      </button>
    </div>
  );
}

